<template>
  <div>
    <v-row align="center">
      <v-col cols class="text-start">
        <span class="textLight--text font-weight-medium text-h5 text-start">
          {{ $t("quiz.assessments") }}
        </span>
      </v-col>

      <v-col cols="12" sm="6" md="4" lg="3">
        <v-text-field
          v-model="search"
          hide-details
          prepend-inner-icon="mdi-magnify"
          color="primary"
          :placeholder="$t('course.search')"
          solo
          flat
          clearable
          class="shrink rounded-lg"
        />
      </v-col>
    </v-row>

    <v-container v-if="hasLoadingError" fill-height class="my-16">
      <Error />
    </v-container>

    <v-row v-else-if="isLoading">
      <v-col>
        <AssignedCourseLoader />
      </v-col>
    </v-row>

    <template v-else-if="assessments.length">
      <v-row>
        <v-col
          v-for="(assessment, index) in assessments"
          :key="index"
          cols="12"
          sm="6"
          md="4"
          lg="3"
          xl="2"
        >
          <AvailableAssessmentCard :assessment="assessment" />
        </v-col>
      </v-row>

      <v-row justify="end">
        <v-col>
          <Pagination :length="totalPages" @onPageSelect="onPagination" />
        </v-col>
      </v-row>
    </template>

    <v-row v-else justify="center" align="center">
      <v-col cols="10" sm="8" lg="6">
        <empty-courses
          :heading="$t('quiz.noAssessmentsMessage')"
          :isOnSide="false"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import AvailableAssessmentCard from "../components/AvailableAssessmentCard.vue";
import EmptyCourses from "../../course-module/components/EmptyCourses.vue";
import AssignedCourseLoader from "../../course-module/components/skeleton-loaders/AssignedCourseLoader";
import Error from "@/app/core-module/components/Error";
import Pagination from "@/app/core-module/components/Pagination";

const defaultLimit = 6;

export default {
  name: "AvailableAssessmentList",
  components: {
    Pagination,
    Error,
    AssignedCourseLoader,
    AvailableAssessmentCard,
    EmptyCourses,
  },
  data() {
    return {
      hasLoadingError: false,
      isLoading: true,
      pageInput: this.defaultPageInput(defaultLimit),
      assessments: [],
      totalCount: 0,

      filterInput: null,
      search: null,
      debounceSearch: null,
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.totalCount / this.pageInput.limit);
    },
  },
  apollo: {
    getQuizContents() {
      return {
        query: require("../api/query/getQuizContents.gql"),
        variables: this.getVariables(),
        result({ data, loading }) {
          if (data?.getQuizContents?.quizContents) {
            this.assessments = data.getQuizContents.quizContents ?? [];
            this.totalCount = data.getQuizContents.totalCount ?? 0;
          } else {
            this.hasLoadingError = true;
          }

          this.isLoading = loading;
        },
      };
    },
  },
  watch: {
    search() {
      clearTimeout(this.debounceSearch);
      this.debounceSearch = setTimeout(this.apiSearch, 500);
    },
  },
  methods: {
    getVariables() {
      return { pageInput: this.pageInput, filterInput: this.filterInput };
    },
    reFetch() {
      this.$apollo.queries.getQuizContents.refetch(this.getVariables());
    },
    apiSearch() {
      const searchText = this.search?.trim() ?? "";

      if (searchText.length > 3) {
        this.pageInput = this.defaultPageInput(defaultLimit);
        this.filterInput = { search: searchText };
        this.reFetch();
      } else if (searchText.length === 0 && this.filterInput?.search != null) {
        this.pageInput = this.defaultPageInput(defaultLimit);
        this.filterInput = null;
        this.reFetch();
      }
    },
    onPagination(page) {
      if (page > 0) {
        this.pageInput.skip = this.pageInput.limit * (page - 1);
        this.reFetch();
      }
    },
  },
};
</script>
